import { render } from "./SegmentationPromptAI.vue?vue&type=template&id=c718a770&scoped=true"
import script from "./SegmentationPromptAI.vue?vue&type=script&lang=ts"
export * from "./SegmentationPromptAI.vue?vue&type=script&lang=ts"

import "./SegmentationPromptAI.vue?vue&type=style&index=0&id=c718a770&lang=scss"
import "./SegmentationPromptAI.vue?vue&type=style&index=1&id=c718a770&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c718a770"

export default script